<template>
    <div class="container">
        <div class="step-indicator only-mobile">Schritt {{ step }} / {{ isHPS(leadin) ? '4' : '5' }}</div>
        <div class="content__topbar" id="topbar">
            <span class="topbar__txt">Online-Antrag</span>
                <span v-on:click="back(step)" class="back-link d-tablet"><span class="back-link__icon icon-left-arrow"></span>Zurück</span>
        </div>
        <div :class="cssclass">
            <h1>{{ header }}</h1>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        step: {
            type: String,
            default() {
                return 1
        }},
        header: {
            type: String,
            default() {
                return ''
        }},
        leadin: {
          type: Object,
          default() {
            return {}
        }},
        cssclass: {
            type: String,
            default() {
                return 'content__heading'
        }}
    },
    methods: {
      back(place) {
        let where = {1: 'tier', 2: 'persoenliche-daten', 3: 'gesundheit', 4: 'zahlung'};
        if (this.isHPS(this.leadin)) {
          where = {1: 'tier', 2: 'persoenliche-daten', 3: 'zahlung'};
        }
        let backPlace = place - 1;
        this.$parent.$parent.back(backPlace, where[backPlace])
   /*     componentOrder: ['Pet', 'Person', 'Tarif', 'Payment'],

        componentsArray:{start: 'Pet', advancePet: 'Person', advancePerson: 'Payment', advancePayment: 'Checkout'},
        hashComponentsArray: {start: 'tier', advancePet: 'persoenliche-daten', advancePerson: 'zahlung', advancePayment: 'zusammenfassung'},
        hashComponentsCurArray: {'tier': 'Pet', 'persoenliche-daten': 'Person', 'zahlung': 'Payment', 'zusammenfassung':'Checkout'},

        this.lead.place = place
        history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#' + where)
        this.currentComponent = this.hashComponentsCurArray[where]
        document.getElementById('jumppoint').scrollIntoView();*/
      }
	}
}
</script>
<style scoped>
.lessmargin {
    margin-bottom:25px;
}
</style>
